import {
  faFileAlt,
  faTicketAlt,
  faUserAlt,
  faUsers
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FalconComponentCard from 'components/common/FalconComponentCard';
import Flex from 'components/common/Flex';
import { useEffect, useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom';

const ReportList = ({ reportName }) => {
  const reports = [
    {
      name: 'Visão Geral do Service Desk',
      value: '/reports/overview',
      icon: faTicketAlt
    },
    {
      name: 'Análise de Produtividade',
      value: '/reports/productivity-analysis',
      icon: faUsers
    },
    {
      name: 'Resumo Executivo',
      value: '/reports/executive',
      icon: faUserAlt
    },
    {
      name: 'Relatórios Personalizados',
      value: '/reports/custom',
      icon: faFileAlt
    }
  ];

  const location = useLocation();
  const navigate = useNavigate();

  // Função para determinar se estamos em uma rota de relatórios personalizados
  const isCustomReportRoute = () => {
    return location.pathname.startsWith('/reports/custom');
  };

  // Função para determinar qual relatório está ativo baseado na rota atual
  const getActiveReport = () => {
    if (isCustomReportRoute()) {
      return reports.find(report => report.value === '/reports/custom');
    }
    return (
      reports.find(report => report.value === location.pathname) || reports[0]
    );
  };

  const [selectedReport, setSelectedReport] = useState(getActiveReport());

  useEffect(() => {
    const activeReport = getActiveReport();
    setSelectedReport(activeReport);
    reportName(activeReport.name);
  }, [location.pathname, reportName]);

  const handleReportClick = report => {
    setSelectedReport(report);
    navigate(report.value);
  };

  return (
    <FalconComponentCard
      className="position-sticky top-0"
      style={{ height: '85vh' }}
    >
      <FalconComponentCard.Header title="Relatórios" />
      <Card.Body className="p-0">
        <Flex direction="column" alignItems="start">
          {reports.map(item => (
            <Button
              key={item.value}
              onClick={() => handleReportClick(item)}
              variant="link"
              size="sm"
              className={`d-flex align-items-center w-100 py-2 rounded text-body${
                selectedReport.name === item.name ? ' bg-100' : ''
              }`}
              style={{ textDecoration: 'none' }}
            >
              <FontAwesomeIcon
                icon={item.icon}
                className={`me-2${
                  selectedReport.name === item.name
                    ? ' text-primary'
                    : ' text-secondary'
                }`}
              />
              {item.name}
            </Button>
          ))}
        </Flex>
      </Card.Body>
    </FalconComponentCard>
  );
};

export default ReportList;
